<template>
  <div>
    <el-dialog title="选择预算计划" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1200px">
      <div style="height: 500px;">
        <el-table
          :data="tableData"
          style="width: 100%;margin-bottom: 20px;"
          height="485px"
          row-key="id"
          border
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column width="150" prop="account_code" label="科目代码" ></el-table-column>
          <el-table-column width="150" prop="account_name" label="科目名称"></el-table-column>
          <el-table-column label="1月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M1MoneyPre.is_apply == 0">
                {{scope.row.M1MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 1, scope.row.M1MoneyPre.money)">{{scope.row.M1MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="2月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M2MoneyPre.is_apply == 0">
                {{scope.row.M2MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 2, scope.row.M2MoneyPre.money)">{{scope.row.M2MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="3月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M3MoneyPre.is_apply == 0">
                {{scope.row.M3MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 3, scope.row.M3MoneyPre.money)">{{scope.row.M3MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="4月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M4MoneyPre.is_apply == 0">
                {{scope.row.M4MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 4, scope.row.M4MoneyPre.money)">{{scope.row.M4MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="5月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M5MoneyPre.is_apply == 0">
                {{scope.row.M5MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 5, scope.row.M5MoneyPre.money)">{{scope.row.M5MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="6月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M6MoneyPre.is_apply == 0">
                {{scope.row.M6MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 6, scope.row.M6MoneyPre.money)">{{scope.row.M6MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="7月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M7MoneyPre.is_apply == 0">
                {{scope.row.M7MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 7, scope.row.M7MoneyPre.money)">{{scope.row.M7MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="8月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M8MoneyPre.is_apply == 0">
                {{scope.row.M8MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 8, scope.row.M8MoneyPre.money)">{{scope.row.M8MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="9月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M9MoneyPre.is_apply == 0">
                {{scope.row.M9MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 9, scope.row.M9MoneyPre.money)">{{scope.row.M9MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="10月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M10MoneyPre.is_apply == 0">
                {{scope.row.M10MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 10, scope.row.M10MoneyPre.money)">{{scope.row.M10MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="11月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M11MoneyPre.is_apply == 0">
                {{scope.row.M11MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 11, scope.row.M11MoneyPre.money)">{{scope.row.M11MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="12月">
            <template slot-scope="scope">
              <template v-if="scope.row.children.length > 0 || scope.row.M12MoneyPre.is_apply == 0">
                {{scope.row.M12MoneyPre.money}}
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="selectItem(scope.row, 12, scope.row.M12MoneyPre.money)">{{scope.row.M12MoneyPre.money}}</a>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false;callback=undefined">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from "../common/Http";

export default {
  name: "SelectBudgetItemsByMonth",
  data(){
    return{
      dialogVisible:false,
      tree_str:"",
      id:"",
      tree_obj:{},
      name:"id",
      value:"",
      callback:null,
      tableData: [

      ]
    }
  },
  mounted() {

  },
  methods:{
    show(config,callback){
      console.info(config)
      const that = this;
      that.dialogVisible=true;
      that.callback=callback;
      let budgetUrl = window.Glob.budget;
      Http.get(budgetUrl + "/admin/BudgetSendApi/sendAdjuctApply?",config,function (res) {
        if (res.code) {
          that.tableData = res.data
        }
      })
    },

    selectItem(data, month, amount){
      data['select_month'] = month
      data['select_amount'] = amount
      const that = this;
      typeof that.callback==="function"&&that.callback(data)
      that.dialogVisible=false;
      that.callback=undefined;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/SelectBudgetItemsByMonth.vue